import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

type SingleArmInput = {
  arm_type_uid: string;
  name: string;
  short_name: string;
  randomization_group: string;
  code: string;
  description: string;
};
type ArmsInput = {
  all_arms: SingleArmInput[];
}

@Component({
  selector: 'app-endpoints',
  imports: [],
  templateUrl: './arms.component.html',
  styleUrl: './arms.component.css'
})
export class ArmsComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Arms';
  private usdmSub: Subscription | null = null;
  data: ArmsInput | null = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as ArmsInput;
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

}
